Date.format = function(fmt, time){
	var nums = function(num, cnt){
		var res = '' + num;
		while (res.length < cnt){
			res = '0' + res;
		}
		return res;
	};

	if (time == undefined){
		time = Date.now();
	}
	time = +time;
	var date = new Date(time);

	return fmt
		.replace(/%H/g, nums(date.getHours(), 2))
		.replace(/%M/g, nums(date.getMinutes(), 2))
		.replace(/%S/g, nums(date.getSeconds(), 2))

		.replace(/%d/g, nums(date.getDate(), 2))
		.replace(/%m/g, nums(date.getMonth() + 1, 2))
		.replace(/%y/g, nums(date.getFullYear(), 4))
	;
}

RegExp.escape = function(str){
	return str.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, "\\$&");
};
